export const InventoryHelp = ({props}) => {
    return <div style={{textAlign: 'left'}}>
        <p>
            <b>Products</b><br/>
            Products contain descriptive information about items in inventory.
            An example of a product might be "Super Runtz"
        </p>
        <p>
            <b>Category</b><br/>
            There are three categories of products.<br/>
            1) <b>Wholesale</b> - these are the products that are grown and harvested in batches. <br/>
            2) <b>Packaged</b> - these are products that are created by the Fulfilment department. <br />
            3) <b>Supplies</b> - these are products like lids or jars that are purchased from vendors. <br/>
        </p>
        <p>
            <b>Inventory</b><br/>
            Inventory describes how much of a product we have as well as its associated cost.<br/>
            At any time we might have multiple groups of inventory for 1 product. <br/>
            For ex  ample, we might have 100 "Super Runtz" from January that cost $1000. And we
            might also have 200 "Super Runtz" from February that cost $3000. <br />
            Wholesale inventory currently uses <b>grams</b> as the unit of measure.
        </p>
    </div>
}